import React from 'react';
import AppLayout from '../../components/AppLayout';
import OverviewList from '../../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,AddListItem,
        Segment,LoadGraphic,Step,DynamicListArea,BulkEdit} from '../../components/Common';
import {Input,Button,Area,MiniMinusButton,Checkbox,
        PageSelector,Box,TextButton,Select} from '../../components/Input';
import u from '../../utilities/Utilities';
import moment from 'moment';
import '../../styles/inventory/purchase-order.scss';

export default class PurchaseOrderList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"Purchase Order",
        permission:"inventory",  //Accepts combined permission module as well
        //combinedField:"price",     //Used when permission exists in a combined field
        url:"/purchase-order-list",

        /**** Action Setup ****/
        addType:1,
        addURL:"/api/add-purchase-order-entry",
        //templateURL:"/api/get-add-tenant-template",
        //bulkURL:"/api/add-bulk-tenants",
        deleteURL:"/api/delete-purchase-order-entries",
        spreadsheetURL:"/api/generate-purchase-order-spreadsheet",
        overviewURL:"/api/get-all-purchase-order-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"purchase-order-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
        options:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (bulkEditOptions.length > 0 && (permissions.update));
        this.setState({
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.create==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
                {label:"Configure Supplier",ref:"supplier",enabled:(permissions.delete==2),onClick:this.onItemSupplier},
            ],
            permissions:permissions,
        });
    }

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    }

    onItemSupplier=()=>{
        this.props.history.push("/item-supplier-list");
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>
                <div className="page-error-container">
                    <div className="page-error">{this.state.error}</div>
                </div>

                <PageMenu buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                              index={index}
                                              content={content}
                                              onChange={onChange}
                                              onContentChange={onContentChange}
                                              registerReference={registerRef}
                                              options={this.state.options}
                                              settings={this.settings}
                                              permissions={this.state.permissions}
                                              />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{

    pageLength = 10;

    r={};

    state={
        step:"view",
        error:"",
        loading:false,
        loadText:"",
        startIndex:0,
        endIndex:this.pageLength,
        page:1,
        itemOptions:[],
        deliverables:[],
        confirmed:false,
    };

    static getDerivedStateFromProps(props,state){
        const maxPage = Math.ceil(props.content.purchaseItems.length/10);

        if(props.content.listID != state.listID){
            state.listID=props.content.listID;
            state.startIndex=0;
            state.endIndex=10;
            state.page=1;
        }

        if(state.page > maxPage){
            state.page = maxPage;
            state.startIndex = (maxPage-1)*10;
            state.endIndex=state.startIndex + 10;
        }
        
        return state;
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * this.pageLength;
        const endIndex = startIndex + this.pageLength;
        this.setState({page:newPage,startIndex:startIndex,endIndex:endIndex});
    }

    onOrdered=async ()=>{
        this.setState({loading:true,loadText:"Updating..."});
        try{
            const {content}=this.props;
            const newStatus = "Ordered";
            await u.postAsync({
                url:"/api/update-purchase-order-info",
                data:{
                    oldValue:content.status,
                    newValue:newStatus,
                    field:"status",
                    id:content.listID,
                }
            });
            this.props.onChange(newStatus,"status",this.props.index);
            this.setState({loading:false,step:"view",error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({loading:false,error:error});
        }
    }

    onDeliveryRequest=()=>{
        const {content}=this.props;
        const deliverables = content.purchaseItems.filter((item)=>{
            return parseInt(item.quantity) - parseInt(item.deliveredQuantity) > 0;
        }).map((item)=>{
            const expected = parseInt(item.quantity) - parseInt(item.deliveredQuantity);
            item.expectedQuantity = expected;
            item.currentDeliveredQuantity = expected;
            return item;
        });
        this.setState({deliverables:deliverables,step:'delivery',error:""});
    }

    onAddRequest=async ()=>{
        this.setState({loading:true,loadText:"Preparing..."});
        const {content}=this.props;
        try{
            const response = await u.postAsync({
                url:"/api/get-supplier-item-options",
                data:{
                    supplierID:content.itemSupplierID,
                },
            });
            this.setState({
                itemOptions:response.data,
                step:"add",
                error:"",
                loading:false
            });
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onRemoveRequest=(index)=>{
        const {content}=this.props;
        this.setState({
            remove:content.purchaseItems[index],
            removeIndex:index,
            step:"remove",
            error:"",
        });
    }

    onConfirmAdd=async ()=>{
        const keys=["itemID","quantity"];
        let data={};
        for(var i=0; i<keys.length; i++){
            const current=this.r[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data[keys[i]]=current.value;
        }

        this.setState({loading:true,loadText:"Adding.."});
        try{
            const {content}=this.props;
            const response=await u.postAsync({
                url:"/api/add-purchase-order-item",
                data:{
                    purchaseOrderID:content.listID,
                    ...data,
                }
            });
            content.purchaseItems.push(response.data);
            this.props.onChange(content.purchaseItems,"purchaseItems",this.props.index);
            this.setState({step:"view",loading:false,error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onConfirmRemove=async ()=>{
        this.setState({loading:true,loadText:"Removing..."});
        try{
            let {content}=this.props;
            const {remove,removeIndex}=this.state;
            const response=await u.postAsync({
                url:"/api/remove-purchase-order-item",
                data:{
                    purchaseOrderID:content.listID,
                    remove:remove
                }
            });
            content.purchaseItems.splice(removeIndex,1);
            this.props.onChange(content.purchaseItems,"purchaseItems",this.props.index);
            this.setState({step:'view',error:"",loading:false});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onConfirmDelivery=async ()=>{
        const {content}=this.props;
        const {deliverables}=this.state;
        for(var i=0; i<deliverables.length; i++){
            const current=this.r['cdq-'+i].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
        }
        this.setState({loading:true,loadText:"Updating..."});
        try{

            const delivered=deliverables.map((item)=>{
                return {
                    itemID:item.itemID,
                    currentDeliveredQuantity:item.currentDeliveredQuantity
                }
            });

            const response = await u.postAsync({
                url:"/api/purchase-order-receive-delivery",
                data:{
                    purchaseOrderID:content.listID,
                    delivered:delivered,
                    expected:content.purchaseItems,
                }
            });

            //Merge deliverables
            const expected=content.purchaseItems;
            for(var i=0; i<expected.length; i++){
                for(var j=0; j<delivered.length; j++){
                    if(expected[i].itemID == delivered[j].itemID){
                        expected[i].deliveredQuantity = parseInt(expected[i].deliveredQuantity) + parseInt(delivered[j].currentDeliveredQuantity);
                    }
                }
            }
            this.props.onChange(expected,"purchaseItems",this.props.index);
            this.props.onChange(response.data,"status",this.props.index);
            this.setState({step:"view",loading:false,error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onChangeDelivery=(value,label,index)=>{
        let {deliverables}=this.state;
        deliverables[index][label]=value;
        this.setState({deliverables:deliverables});
    }

    render=()=>{
        const {content,options,settings,onChange,permissions} = this.props;
        const {step,startIndex,endIndex,page,confirmed,remove,itemOptions,deliverables} = this.state;
        const maxPage = Math.ceil(content.purchaseItems.length / this.pageLength);
        const canEdit = (permissions.create==2);

        return (
            <div>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>
                <Step active={step == "view"}>
                    <DynamicListArea content={content}
                                     onChange={onChange}
                                     index={this.props.index}
                                     listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     bypassPermission={canEdit}
                                     />
                    
                    {
                        (content.purchaseItems.length > 0)
                            ?
                            <div className='list-table po-list' style={{maxHeight:"none"}}>
                                <h3>Purchased Items</h3>
                                <table>
                                    <thead>
                                        <tr>
                                            <th className='remove left'/>
                                            <th>Item</th>
                                            <th style={{width:"100px"}}>Item Code</th>
                                            <th style={{width:"100px"}}>Ordered</th>
                                            <th style={{width:"100px"}} className='right'>Delivered</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            content.purchaseItems.map(
                                                (item,index)=>{
                                                    if(index < startIndex || index >= endIndex){
                                                        return null;
                                                    }
                                                    const delivered=(item.quantity == item.deliveredQuantity);
                                                    return (
                                                        <tr key={index} className={delivered ? "delivered" : ""}>
                                                            <td className='remove'>
                                                                {
                                                                    (canEdit)
                                                                        ?
                                                                        <MiniMinusButton
                                                                            index={index}
                                                                            enabled={canEdit && item.deliveredQuantity==0}
                                                                            onClick={this.onRemoveRequest}
                                                                            />        
                                                                        :
                                                                        (index+1)+"."
                                                                }
                                                            </td>
                                                            <td>{item.itemName}</td>
                                                            <td>{item.itemCode}</td>
                                                            <td>{item.quantity} {item.purchaseQuantifier}</td>
                                                            <td>{item.deliveredQuantity} {item.purchaseQuantifier}</td>
                                                        </tr>
                                                    )
                                                }
                                            )
                                        }
                                    </tbody>
                                </table>
                                {
                                    (maxPage > 1)
                                        ?
                                        <div style={{margin:"20px auto"}}>
                                            <PageSelector maxPage={maxPage}
                                                        page={page}
                                                        onChange={this.onChangePage}
                                                        />
                                        </div>
                                        :
                                        null
                                }
                            </div>
                            :
                            <div className='list-placeholder'>
                                <b>No Items Added</b>
                                <div>Click below to add item</div>
                            </div>
                    }
                    {
                        (canEdit)
                            ?
                            <div style={{margin:"20px auto",textAlign:"center"}}>
                                <TextButton onClick={this.onAddRequest}>Add Item</TextButton>
                            </div>
                            :
                            null
                    }
                    
                    <div style={{margin:'30px auto',textAlign:"center"}}>
                        {
                            (canEdit && content.status == "Draft")
                                ?
                                <Button onClick={()=>{this.setState({step:"order",error:""})}}>Ordered</Button>
                                :
                                null
                        }
                        {
                            (canEdit && (content.status == "Ordered" || content.status == "Partially Delivered"))
                                ?
                                <Button onClick={this.onDeliveryRequest}>Confirm Delivery</Button>
                                :
                                null
                        }
                    </div>
                </Step>

                <Step active={step=="add"} scroll={true}>
                    <div style={{padding:"30px 0",position:"relative",textAlign:"center"}}>
                        <h2>Select item to add</h2>

                        <div style={{position:"relative",fontSize:"14px"}}>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Item:</div>
                                <div className='segment-item-input'>
                                    <Select ref={(ref)=>{this.r['itemID']=ref}}
                                            label="Item"
                                            values={{options:itemOptions}}
                                            rules={{required:true}}
                                            />
                                </div>
                            </div>
                            <div className='segment-full-item'>
                                <div className='segment-item-label'>Quantity:</div>
                                <div className='segment-item-input'>
                                    <Box ref={(ref)=>{this.r['quantity']=ref}}
                                         label="Quantity"
                                         type="number"
                                         rules={{required:true,minValue:0}}
                                         />
                                </div>
                            </div>
                        </div>

                        <div className='list-segment-note'>
                            Item must already be approved and added to this supplier's list to be selected
                        </div>

                        <div style={{margin:"20px auto 0 auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmAdd}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="remove"} scroll={true}>
                    <div style={{position:"relative",padding:"30px 0",textAlign:"center"}}>
                        <h2 className='text-negative'>Confirm Removal of {remove?.itemName}?</h2>
                        <div className='list-segment-note'>Note. This action cannot be undone</div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onConfirmRemove}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="order"} scroll={true}>
                    <div style={{position:"relative",textAlign:"center",padding:"30px 0"}}>
                        <h2 className='text-emphasis'>Confirm P.O. sent to {content.supplierCompanyName}?</h2>
                        <div className='list-segment-note'>
                            Note. Store items will only be updated once delivery is confirmed
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onOrdered}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="delivery"} scroll={true}>
                    <div style={{position:"relative",textAlign:"center",padding:"10px 0"}}>
                        <h2>Select the items that have been delivered</h2>
                        <div className='list-table' style={{maxHeight:"none"}}>
                            <table>
                                <thead>
                                    <tr>
                                        <th className='remove left'/>
                                        <th>Item</th>
                                        <th style={{width:"120px"}}>Item Code</th>
                                        <th style={{width:"120px"}}>Expected</th>
                                        <th style={{width:"120px"}} className='right'>Delivered</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {
                                    deliverables.map(
                                        (item,index)=>{
                                            return (
                                                <tr key={index}>
                                                    <td className='remove'>{(index+1)}.</td>
                                                    <td>{item.itemName}</td>
                                                    <td>{item.itemCode}</td>
                                                    <td>{item.expectedQuantity} {item.purchaseQuantifier}</td>
                                                    <td>
                                                        <Box ref={(ref)=>{this.r['cdq-'+index]=ref}}
                                                            values={{value:item.currentDeliveredQuantity}}
                                                            onChange={this.onChangeDelivery}
                                                            type="number"
                                                            label="Delivered Quantity"
                                                            field="currentDeliveredQuantity"
                                                            index={index}
                                                            rules={{
                                                                minValue:0,
                                                                required:true,
                                                                maxValue:item.expectedQuantity
                                                            }}
                                                            />
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    )
                                }
                                </tbody>
                            </table>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <Checkbox values={{value:confirmed}}
                                    onChange={(value)=>{this.setState({confirmed:value})}}
                                    />

                            Items delivered are in good condition and in the quantities reflected above
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button enabled={confirmed} onClick={this.onConfirmDelivery}>Confirm</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{
    r={};

    settings={
        addType:0,
        addURL:"/api/add-store-item-entry",
    }

    state={
        step:"view",
        entryData:{
            purchaseItems:[
                {itemID:"none",quantity:"0",purchaseQuantifier:"-"},
            ],
        },
        supplierOptions:[],
        itemOptions:[],
    }

    componentDidMount=()=>{
        this.getSupplierOptions();
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({error:""});
        }
    }

    getSupplierOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-item-supplier-options",
                data:{}
            });
            response.data.unshift({value:"none",label:"Select Supplier"});
            this.setState({supplierOptions:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const {entryData}=this.state;
        const keys = fields.map((item)=>{return item.field});
        let data = {};
        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                data[keys[i]]=current.value;
            }
        }

        for(var j=0; j<entryData.purchaseItems.length; j++){
            const subkeys=["itemID","quantity"];
            for(var k=0; k<subkeys.length; k++){
                const current = this.r[subkeys[k]+"-"+j].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
            }
        }
        
        this.r[this.props.reference].onValidated(entryData);
    }

    onComplete=()=>{
        this.setState({
            entryData:{
                purchaseItems:[{itemID:"none",quantity:"0",purchaseQuantifier:"-"}],
            },
            step:"view"
        });
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        if(label=="itemSupplierID"){
            entryData.purchaseItems=[{itemID:"none",quantity:"0"}];
            this.setState({itemOptions:[]});
            this.onChangeSupplier(value);
        }
        this.setState({entryData:entryData});
    }

    onChangeSupplier=async (value)=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-supplier-item-options",
                data:{
                    supplierID:value
                }
            });
            response.data.unshift({value:"none",label:"Select Item",purchaseQuantifier:"-"});
            this.setState({itemOptions:response.data});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onRemoveItem=(index)=>{
        let {entryData}=this.state;
        entryData.purchaseItems.splice(index,1);
        this.setState({entryData:entryData});
    }

    onChangeItem=(value,label,index,option)=>{
        let {entryData}=this.state;
        entryData.purchaseItems[index][label]=value;
        if(label == "itemID"){
            entryData.purchaseItems[index].purchaseQuantifier=option.purchaseQuantifier;
        }
        this.setState({entryData:entryData});
    }

    onAddItem=()=>{
        let {entryData}=this.state;
        entryData.purchaseItems.push({itemID:"none",quantity:"0",purchaseQuantifier:"-"});
        this.setState({entryData:entryData});
    }

    render=()=>{
        const {loading,loadText,step,itemOptions,supplierOptions,entryData}=this.state;
        const fields=[
            {dataType:"select",label:"Supplier",field:"itemSupplierID",rules:{required:true},options:supplierOptions},
            {dataType:"box",label:"P.O. Number",field:"purchaseOrderNo",rules:{required:true}},
        ];

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={true}
                         onToggleForm={this.props.onToggleForm}
                         >
                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="view"}>
                        <h3>Complete the following fields to continue</h3>
                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                 value:entryData[item.field],
                                                 options:item.options
                                               }}
                                               fields={{
                                                    ...item,
                                                    onChange:this.onChange
                                                }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }

                        <h4 style={{marginTop:"30px"}}>P.O. Items</h4>
                        <div style={{position:"relative",width:"800px",margin:"0 auto 30px auto",maxHeight:"none",fontSize:"12px"}} className='list-table'>
                            <table>
                                <thead>
                                    <tr>
                                        <th className='remove left'/>
                                        <th>Item</th>
                                        <th style={{width:"60px"}}>Quantity</th>
                                        <th style={{width:"100px"}} className='right'/>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        entryData.purchaseItems.map(
                                            (item,index,piArr)=>{
                                                return (
                                                    <tr key={index}>
                                                        <td className='remove'>
                                                            <MiniMinusButton index={index} enabled={piArr.length > 1} onClick={this.onRemoveItem}/>
                                                        </td>
                                                        <td>
                                                            <Select ref={(ref)=>{this.r['itemID-'+index]=ref}}
                                                                    values={{
                                                                      value:item.itemID,
                                                                      options:itemOptions
                                                                    }}
                                                                    label='Item'
                                                                    field="itemID"
                                                                    index={index}
                                                                    onChange={this.onChangeItem}
                                                                    promptParentDefault={true}
                                                                    rules={{required:true}}
                                                                    />
                                                        </td>
                                                        <td>
                                                            <Box ref={(ref)=>{this.r['quantity-'+index]=ref}}
                                                                 values={{
                                                                    value:item.quantity,
                                                                 }}
                                                                 label="Quantity"
                                                                 field="quantity"
                                                                 index={index}
                                                                 type="number"
                                                                 onChange={this.onChangeItem}
                                                                 rules={{required:true,minValue:1}}
                                                                 />
                                                        </td>
                                                        <td>{item.purchaseQuantifier}</td>
                                                    </tr>
                                                )
                                            }
                                        )
                                    }
                                </tbody>
                            </table>

                            <div style={{margin:"20px auto"}}>
                                <TextButton onClick={this.onAddItem}>Add Item</TextButton>
                            </div>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>
                </div>
            </AddListItem>
        )
    }
}